/**
 * Rutas de la SPA bajo el feature de cuentas (listado y ficha).
 */
export function isCuentasFeatureRoute(routerUrl: string): boolean {
  const path = routerUrl.split('?')[0]?.split('#')[0] ?? '';
  return (
    path === '/cuentas' ||
    path.startsWith('/cuentas/') ||
    path === '/partners' ||
    path.startsWith('/partners/')
  );
}

/**
 * Peticiones que consultan o mutan el recurso **cuenta** en sí
 * (listado, básico, ficha por id), no sub-recursos (panel, accesos, familias, etc.).
 */
export function isCuentaInformacionApiUrl(requestUrl: string): boolean {
  let pathname = requestUrl.split('?')[0]?.split('#')[0] ?? '';
  pathname = pathname.replace(/\/+$/, '') || '/';
  if (pathname.startsWith('http://') || pathname.startsWith('https://')) {
    try {
      pathname = new URL(pathname).pathname.replace(/\/+$/, '') || '/';
    } catch {
      // se usa pathname tal cual
    }
  }
  if (/\/api\/cuentas\/basico$/i.test(pathname)) return true;
  if (/\/api\/cuentas\/\d+$/i.test(pathname)) return true;
  if (/\/api\/cuentas$/i.test(pathname)) return true;
  return false;
}
